import React, { useState } from "react";
import "./JobRecruitmentForm.css"; // using the same CSS
import {
  FaBuilding,
  FaUserTie,
  FaEnvelope,
  FaPhone,
  FaGlobe,
  FaFileUpload,
} from "react-icons/fa";

const JoinPartnerForm = () => {
  const [formData, setFormData] = useState({
    companyName: "",
    contactPerson: "",
    email: "",
    phone: "",
    website: "",
    partnershipType: "",
    message: "",
    companyProfile: null,
  });

  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setShowPopup(true);

    // submit to hidden iframe (if you add `action` + `target="hidden_iframe"`)
    e.target.submit();

    // redirect after 3 seconds
    setTimeout(() => {
      window.location.href = "/";
    }, 3000);
  };

  return (
    <div className="job-form-container">
      <h2>Become Our Partner</h2>
      <form
        onSubmit={handleSubmit}
        method="POST"
        target="hidden_iframe"
        // 🔹 add Salesforce/Google form action here if needed
        action=""
      >
        {/* Company Name */}
        <div className="form-group">
          <label>Company Name:</label>
          <div className="input-icon">
            <FaBuilding />
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              placeholder="Enter company name"
              required
            />
          </div>
        </div>

        {/* Contact Person */}
        <div className="form-group">
          <label>Contact Person:</label>
          <div className="input-icon">
            <FaUserTie />
            <input
              type="text"
              name="contactPerson"
              value={formData.contactPerson}
              onChange={handleChange}
              placeholder="Enter contact person's name"
              required
            />
          </div>
        </div>

        {/* Email */}
        <div className="form-group">
          <label>Email:</label>
          <div className="input-icon">
            <FaEnvelope />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
              required
            />
          </div>
        </div>

        {/* Phone */}
        <div className="form-group">
          <label>Phone Number:</label>
          <div className="input-icon">
            <FaPhone />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter phone number"
              required
            />
          </div>
        </div>

        {/* Website */}
        <div className="form-group">
          <label>Website:</label>
          <div className="input-icon">
            <FaGlobe />
            <input
              type="url"
              name="website"
              value={formData.website}
              onChange={handleChange}
              placeholder="Enter website (optional)"
            />
          </div>
        </div>

        {/* Partnership Type */}
        <div className="form-group">
          <label>Partnership Type:</label>
          <select
            name="partnershipType"
            value={formData.partnershipType}
            onChange={handleChange}
            required
          >
            <option value="">Select partnership type</option>
            <option value="technology">Technology Partner</option>
            <option value="business">Business Partner</option>
            <option value="investment">Investment Partner</option>
            <option value="other">Other</option>
          </select>
        </div>

        {/* Message */}
        <div className="form-group">
          <label>Message:</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Write your message here..."
            rows="4"
          ></textarea>
        </div>

        {/* File Upload */}
        <div className="form-group">
          <label>Upload Company Profile:</label>
          <div className="input-icon">
            <FaFileUpload />
            <input
              type="file"
              name="companyProfile"
              onChange={handleChange}
              accept=".pdf,.doc,.docx"
            />
          </div>
        </div>

        {/* Submit */}
        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>

      {/* Hidden iframe */}
      <iframe name="hidden_iframe" style={{ display: "none" }}></iframe>

      {/* Popup */}
      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <h3>Thank you!</h3>
            <p>We will contact you soon.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default JoinPartnerForm;
